import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=a5e8ead0&scoped=true&"
import script from "./OrderHeader.vue?vue&type=script&lang=js&"
export * from "./OrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=a5e8ead0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e8ead0",
  null
  
)

export default component.exports